import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './My.css';
import Home from "./Component/Pages/Home";
import Login from "./Component/Pages/Login";
import Buy from "./Component/Pages/Buy";
import Men from "./Component/Pages/Men";
import Women from "./Component/Pages/Women";
import Navbar from "./Component/Navbar";
import Checkout from "./Component/Pages/Checkout";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Page refresh hone ke baad bhi user ka data save rahe
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <BrowserRouter>
      <Navbar user={user} handleLogout={handleLogout} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/men" element={<Men />} />
        <Route path="/women" element={<Women />} />
        <Route path="/checkout" element={<Checkout/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
